export const API_KEY="AIzaSyBvIX_3L-CvxkoneksT9BLJrZ6bXc6EGo4";
export default API_KEY;